<template>
  <div v-loading="loading">
    <el-table :data="features" style="width: 100%" :default-sort = "{ prop: 'desc', order: 'ascending' }" empty-text="No product features were found.">
      <el-table-column label="Feature" prop="title"></el-table-column>
      <el-table-column label="Operations">
        <template slot-scope="props">
          <product-item-feature-edit :productId="product.id" :feature="props.row" @update="refreshFeatures" />
          <product-item-feature-delete :featureId="props.row.id" @delete="refreshFeatures" />
        </template>
      </el-table-column>
    </el-table>
    <section class="my-4">
      <product-item-feature-create :productId="product.id" @create="refreshFeatures" />
    </section>
  </div>
</template>

<script>
import ProductItemFeatureCreate from '@/components/Product/Item/ProductItemFeatureCreate'
import ProductItemFeatureEdit from '@/components/Product/Item/ProductItemFeatureEdit'
import ProductItemFeatureDelete from '@/components/Product/Item/ProductItemFeatureDelete'

export default {
  props: {
    product: Object,
  },
  components: {
    ProductItemFeatureCreate,
    ProductItemFeatureEdit,
    ProductItemFeatureDelete,
  },
  data() {
    return {
      loading: false,
      features: this.product.features,
    }
  },
  methods: {
    async refreshFeatures() {
      this.loading = true
      try {
        var { data } = await this.$http.get(`/products/${ this.product.id }`)
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }
      this.features = data.features
    },
  },
}
</script>
